export default "__VITE_ASSET__CyTM9l4Z__"